import { TRANSLATE_VALUES } from '../keyframes';

type Position = 'left' | 'right';

export function getTranslateValue(
  position: Position,
  isVisible: boolean,
  isSlideStart = false
): string {
  if (isVisible) {
    return TRANSLATE_VALUES.VISIBLE;
  }

  if (isSlideStart) {
    return position === 'right'
      ? TRANSLATE_VALUES.SLIDE_START_RIGHT
      : TRANSLATE_VALUES.SLIDE_START_LEFT;
  }

  return position === 'right'
    ? TRANSLATE_VALUES.HIDDEN_RIGHT
    : TRANSLATE_VALUES.HIDDEN_LEFT;
}
